/**
 * Brand configuration (GETRAC). Vite inlines VITE_BRAND_* at build time.
 * Blank values fall back to defaults. Values containing "[" or "]" are
 * placeholder text: they are ignored (default used) with a single warning.
 * The resolving logic and defaults live in brandDefaults.js so vite.config
 * (index.html and manifest) reads the very same values.
 */
import { resolveBrand } from './brandDefaults';

const resolved = resolveBrand(import.meta.env || {});

export const BRAND = Object.freeze({
  productName: resolved.productName,
  legalEntity: resolved.legalEntity,
  companyReg: resolved.companyReg,
  ownerLine: resolved.ownerLine,
  supportEmail: resolved.supportEmail,
  privacyEmail: resolved.privacyEmail,
  salesEmail: resolved.salesEmail,
  domain: resolved.domain,
  appUrl: resolved.appUrl,
  apiUrl: resolved.apiUrl,
});

// Live URL until DNS cutover (BRAND-D20); used for og:url / og:image.
export const publicUrl = resolved.publicUrl;

export const copyrightLine = (date = new Date()) =>
  `© ${date.getFullYear()} ${BRAND.legalEntity}. All rights reserved.`;

/** Lower-case file-name prefix from the product name, e.g. "getrac". */
export const brandSlug = () =>
  BRAND.productName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'export';

export const pageTitle = (section) =>
  section ? `${section} · ${BRAND.productName}` : BRAND.productName;

/** background = the colour the logo sits on: dark -> reversed, light -> color. */
export const logoSrc = (kind, background) => {
  const logo = resolved.logos[kind] || resolved.logos.horizontal;
  return background === 'dark' ? logo.dark : logo.light;
};
